import React from 'react';
import styled from 'styled-components';
import EditIcon from '@mui/icons-material/Edit';
import ActivateUser from '@mui/icons-material/Check';
import { UserDetailsDto } from '../../../services/User/userService.dto';
import { useUpdateEmail } from '../hooks/useUpdateEmail';
import { theme } from '../../../assets/styles/theme';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

const EmailContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

const EmailText = styled.span`
  flex: 1 1 auto;
  min-width: 0;
  word-break: break-word;
  overflow-wrap: anywhere;
`;

const DraftEmail = styled(EmailText)<{ isActive: boolean }>`
  color: ${({ isActive }) => (isActive ? `${theme.color.blue}` : `${theme.color.black}`)};
  font-style: ${({ isActive }) => (isActive ? 'italic' : 'normal')};
`;

const IconButton = styled.button`
  margin-left: auto;
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border: none;
  background: transparent;
  cursor: pointer;
`;

interface Props {
  user: UserDetailsDto;
  onUpdated?: () => void;
}

const EmailCell = ({ user, onUpdated }: Props) => {
  const { showUpdateEmailPopover, confirmEmail } = useUpdateEmail(onUpdated);
  const showConfirm = user.canEditEmail && !user.blocked && user.userStatus !== 'NEW';
  const showEdit = user.canEditEmail && !user.blocked;

  return (
    <Container>
      {user.email && (
        <EmailContainer>
          <EmailText>{user.email}</EmailText>
          {showEdit && (
            <IconButton onClick={() => showUpdateEmailPopover(user)}>
              <EditIcon style={{ fontSize: 18 }} />
            </IconButton>
          )}
        </EmailContainer>
      )}

      {user.draftEmail && (
        <EmailContainer>
          <DraftEmail isActive={!user.blocked}>{user.draftEmail}</DraftEmail>
          {showConfirm && (
            <IconButton onClick={() => confirmEmail(user)}>
              <ActivateUser style={{ fontSize: 20 }} />
            </IconButton>
          )}
        </EmailContainer>
      )}
    </Container>
  );
};

export default EmailCell;
